import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Col, Container, Input, Row } from 'reactstrap';
import styled from 'styled-components';
import CustomNavbar from '../components/CustomNavbar';
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux';
import { setUser } from '../redux/slices/userSlice';

const Login = () => {

  const navigate = useNavigate();

  const [data, setData] = useState({email: "", password: ""})
  const [colorV, setColorV] = useState("warning")
  const [message, setMessage] = useState("")
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

    const headers = {
      'Content-Type': 'text/plain',
      'Access-Control-Allow-Origin': '*'
    };
    
  const loginUser = (event) => {
    event.preventDefault();
    setMessage("processing")
    axios.post(`https://api.xploreux.techlife-center.com/api/v1/signin`, data, headers)
    .then(res => {
      const datas = res?.data?.data;
      dispatch(setUser(datas));
      setMessage(res?.data?.message)
      setColorV("success")
      setTimeout(() => {navigate("/projects")}, 500)
      
    })
    .catch(error => {
      const errors = error?.response?.data
      setMessage(errors?.message)
      setColorV("danger")

    });
    
  }

  const handleChange = (event) => {
    setData({...data, [event.target.name]: event.target.value})
  }
  
  return (
    <>
    <CustomNavbar colorV="#F5F4FA" navC="light" pos="top" />
    <Container className="d-flex align-items-center justify-content-center" fluid style={{background: "#F5F4FA", minHeight: "100vh"}}>
      <div className="bg-white rounded-lg shadow-sm p-4 p-md-5">
        <Container style={{minWidth: "40vw"}}>
          <Row className="head text-primary justify-content-center text-center pt-3 pb-5">
            <Col xs={6} md={4}>
              <h4 className="mb-0 hoverPointer">LOGIN</h4>
            </Col>
            <Col xs={6} md={4}>
              <h4 className="mb-0 hoverPointer" style={{opacity: "0.6"}} onClick={() => navigate('/signup')}>SIGN UP</h4>
            </Col>
          </Row>
          <Row>
            <Col md={{offset: 1, size: 10}}>
              <form onSubmit={message !="processing"?loginUser:''}>
                <Input type="email" name="email" onChange={handleChange} value={data.email} placeholder="Email Id" autoFocus  required className="rounded-pill mb-3 my-2 text-secondary border-1" />
                <Input type="password" name="password" onChange={handleChange} value={data.password} placeholder="Password" required  className="rounded-pill my-2 mt-4 text-secondary border-1" />
                <Button className="rounded-pill my-2 mt-4 py-2 w-100 border-0" type={message !="processing"?"submit":'button'} color="primary">{message !="processing"?"Login":'Please Wait...'}</Button>
              </form>
              <p className="head mb-0 text-secondary my-3 text-center hoverPointer">Forgot your password?</p>
            </Col>
            <Col>
            </Col>
          </Row>
        </Container>
      </div>
      { message !="processing" && message  ? <CustomAlert color={colorV} className={`font-weight-light mx-3 mb-0  ${colorV === "warning"? "animate__animated animate__fadeInDown animate__faster" : "animate__animated animate__shakeX animate__faster" }`}>{message}</CustomAlert> : "" }
    </Container>
    </>
  );

}

const CustomAlert = styled(Alert)`
  position: absolute;
  bottom: 1rem;
  min-width: 40%;
`

export default Login;